<template>
  <PVInputNumber
    v-model="value"
    :pt="passThroughProps"
    unstyled
  />
</template>
<script lang="ts">
export default {
  name: 'StandardInputNumber',
  compatConfig: { MODE: 3 },
};
</script>

<script setup lang="ts">
import { PassThrough } from '@primevue/core';
import type { InputNumberPassThroughOptions } from 'primevue/inputnumber';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg';
  }>(),
  {
    size: 'md',
  },
);

const value = defineModel<number | null>({ required: true });

const sizeClass = computed((): string => {
  if (props.size === 'md') return '';

  return `form-control-${props.size}`;
});

const passThroughProps = computed((): PassThrough<InputNumberPassThroughOptions> => {
  return {
    pcInputText: {
      root: {
        class: ['form-control', sizeClass.value].join(' '),
      },
    },
  };
});
</script>
